import { FormControl } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

interface ReadonlyDatePickerProps {
  label: string;
  value: string;
}

export const ReadonlyDatePicker = ({ label, value }: ReadonlyDatePickerProps) => {
  return (
    <FormControl fullWidth>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label={label}
          value={new Date(value)}
          disabled
        />
      </LocalizationProvider>
    </FormControl>
  );
};
